import { useState, useEffect, useContext } from "react";
import { Input } from "design-react-kit";
import ModalComponent from "../../Components/ModalComponent";
import Repo from "../../Utility/Repo";
import { useLocation } from "react-router-dom";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function EditRange(props) {
  const apiToken = useContext(TokenContext);
  const [isOpen, toggleModal] = useState(false);
  const [validation, setValidation] = useState(false);
  const [range, setRange] = useState();
  const [loading, setLoading] = useState(true);
  const [isDisabled, setIsDisabled] = useState(true);

  let query = useQuery();

  useEffect(() => {
    setLoading(false);
    if (query.get("range") != null) {
      Repo.getRangeById(apiToken, query.get("range"))
        .then((response) => {
          setRange(response.data);
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });
    }
  }, []);

  const rangeEditValidation = () => {
    setValidation(true);
    let passedValidation = true;

    if (range.name == null) passedValidation = false;
    if (range.min == null) passedValidation = false;
    if (range.max == null) passedValidation = false;
    if (range.fixedCost == null) passedValidation = false;

    if (passedValidation) {
      toggleModal(!isOpen);
    }
  };

  const updateRangeAPI = () => {
    Repo.postUpdateRange(apiToken, JSON.stringify(range))
      .then((response) => {
        if (response.status == 200) {
          window.location.href = props.subfolder + "/fasce";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const checkPercentage = (e) => {
    var perc = e.target.value;

    if (perc <= 100 && perc >= 0) {
      setRange({
        ...range,
        percent: parseInt(perc),
      });
    }
  };

  return (
    <div>
      <h1>Modifica fascia ISEE</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p> </p>
          </div>
		  


              <div className="row">
                <div className="col-lg-4">
                  <Input
                    id="first_name"
                    disabled={isDisabled}
                    label="Nome*"
                    type="text"
                    name="first_name"
                    value={range ? range.name : ""}
                    {...(validation &&
                      !range.name && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                    onChange={(e) =>
                      setRange({ ...range, name: e.target.value })
                    }
                  />
                </div>
                <div className="col-lg-4">
                  <Input
                    id="min_value"
                    disabled={isDisabled}
                    label="Valore Minimo*"
                    type="number"
                    name="min_value"
                    value={range ? range.min.toString() : ""}
                    {...(validation &&
                      !range.min && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                    onChange={(e) =>
                      setRange({ ...range, min: e.target.value })
                    }
                  />
                </div>
                <div className="col-lg-4">
                  <Input
                    id="max_value"
                    disabled={isDisabled}
                    label="Valore Massimo*"
                    type="number"
                    name="max_value"
                    value={range ? range.max.toString() : ""}
                    {...(validation &&
                      !range.max && {
                        infoText: "Il campo non può essere vuoto!",
                        className: "text-danger error_div is-invalid",
                      })}
                    onChange={(e) =>
                      setRange({ ...range, max: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-lg-6">
                  <label htmlFor="percentage">Percentuale</label>
                  <div className="input-number input-number-percentage">
                    <Input
                      id="percentage"
                      disabled={isDisabled}
                      type="number"
                      name="percentage"
                      value={range && range.percent && range.percent.toString()}
                      onChange={(e) => checkPercentage(e)}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <label htmlFor="fixed_cost">Quota Fissa*</label>
                  <div className="input-number input-number-currency">
                    <Input
                      id="fixed_cost"
                      disabled={isDisabled}
                      type="number"
                      name="fixed_cost"
                      step="any"
                      min={0}
                      value={range ? range.fixedCost : ""}
                      {...(validation &&
                        !range.fixedCost && {
                          infoText: "Il campo non può essere vuoto!",
                          className: "text-danger error_div is-invalid",
                        })}
                      onChange={(e) =>
                        setRange({
                          ...range,
                          fixedCost: parseInt(e.target.value),
                        })
                      }
                    />
                  </div>
                </div>
              </div>
              {isDisabled ? (
                <div className="row my-2">
                  <div className="col-lg-12 text-right">
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      data-toggle="tooltip"
                      data-placement="top"
                      onClick={() => setIsDisabled(!isDisabled)}
                      title="Modifica"
                    >
                      Modifica
                    </button>
                  </div>
                </div>
              ) : (
                <div className="row my-2">
                  <div className="col-lg-10 text-right">
                    <button
                      type="button"
                      className="btn btn-outline-info"
                      data-toggle="tooltip"
                      data-placement="top"
                      onClick={() => setIsDisabled(!isDisabled)}
                      title="Indietro"
                    >
                      Indietro
                    </button>
                  </div>
                  <div className="col-lg-2 text-right">
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-toggle="tooltip"
                      data-placement="top"
                      onClick={() => rangeEditValidation()}
                      title="Conferma"
                    >
                      Conferma
                    </button>
                  </div>
                </div>
              )}
       

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Modifica fascia ISEE"
        body="Confermi di voler modificare la fascia ISEE selezionata?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => updateRangeAPI()}
      ></ModalComponent>
      {!loading && <Loader></Loader>}
    </div>
  );
}

export default EditRange;
